'use client';

import { c as _c } from "react/compiler-runtime";
import { FOCUS_RING } from '@common/components/interaction';
import { cn } from '@core/utils';
import { PointCoin } from '@/app/_components/PointCoin';
import { Image } from '@/components/client';
import type { HotDeal } from '../_hooks/useHotDeals';
import { resolveRewardRateLabel } from '../merchants/_utils/formatRewardRate';
import { resolveHotDealPrice } from '../merchants/_utils/resolveHotDeal';
interface HotDealCardProps {
  hotDeal: HotDeal;
  isCompact?: boolean;
  onSelect: () => void;
}
export const HotDealCard = t0 => {
  const $ = _c(47);
  const {
    hotDeal,
    isCompact: t1,
    onSelect
  } = t0;
  const isCompact = t1 === undefined ? false : t1;
  let isPartnerPoint;
  let rewardRateLabel;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== hotDeal || $[1] !== isCompact || $[2] !== onSelect) {
    const {
      price,
      discountRate
    } = resolveHotDealPrice(hotDeal);
    let t9;
    if ($[12] !== hotDeal) {
      t9 = resolveRewardRateLabel(hotDeal);
      $[12] = hotDeal;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    rewardRateLabel = t9;
    isPartnerPoint = hotDeal.rewardCurrencyType === "AFFILIATE_PARTNER_POINT";
    t6 = onSelect;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = cn("group flex min-w-0 flex-1 flex-col gap-8 rounded-large text-left", FOCUS_RING);
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    const t10 = isCompact ? "rounded-xlarge" : "rounded-large";
    let t11;
    if ($[15] !== t10) {
      t11 = cn("relative aspect-square w-full overflow-hidden border border-Gray-black/5 bg-Gray-50", t10);
      $[15] = t10;
      $[16] = t11;
    } else {
      t11 = $[16];
    }
    let t12;
    if ($[17] !== hotDeal.imageUrl) {
      t12 = <Image src={hotDeal.imageUrl} alt="" fill={true} sizes="(min-width: 1280px) 140px, 33vw" className="object-cover" />;
      $[17] = hotDeal.imageUrl;
      $[18] = t12;
    } else {
      t12 = $[18];
    }
    let t13;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <span aria-hidden={true} className="absolute inset-0 bg-Gray-black/0 transition-colors duration-150 group-hover:bg-Gray-black/[0.04] group-focus-visible:bg-Gray-black/[0.04] group-active:bg-Gray-black/[0.04] motion-reduce:transition-none" />;
      $[19] = t13;
    } else {
      t13 = $[19];
    }
    if ($[20] !== t11 || $[21] !== t12) {
      t8 = <div className={t11}>{t12}{t13}</div>;
      $[20] = t11;
      $[21] = t12;
      $[22] = t8;
    } else {
      t8 = $[22];
    }
    t2 = "flex flex-col gap-2";
    let t14;
    if ($[23] !== hotDeal.logoImageUrl) {
      t14 = <Image src={hotDeal.logoImageUrl} alt="" width={16} height={16} className="size-16 shrink-0 rounded-pill object-contain" />;
      $[23] = hotDeal.logoImageUrl;
      $[24] = t14;
    } else {
      t14 = $[24];
    }
    let t15;
    if ($[25] !== hotDeal.merchantName) {
      t15 = <span className="truncate font-600 text-Gray-600 typo-caption2">{hotDeal.merchantName}</span>;
      $[25] = hotDeal.merchantName;
      $[26] = t15;
    } else {
      t15 = $[26];
    }
    if ($[27] !== t14 || $[28] !== t15) {
      t3 = <div className="flex items-center gap-4">{t14}{t15}</div>;
      $[27] = t14;
      $[28] = t15;
      $[29] = t3;
    } else {
      t3 = $[29];
    }
    if ($[30] !== hotDeal.itemName) {
      t4 = <p className="line-clamp-2 font-600 text-Gray-800 typo-caption1">{hotDeal.itemName}</p>;
      $[30] = hotDeal.itemName;
      $[31] = t4;
    } else {
      t4 = $[31];
    }
    t5 = price === null ? null : <p className="flex items-baseline gap-4 text-Gray-black typo-body4">{discountRate === null ? null : <span className="font-700 text-R-400">{discountRate}%</span>}<span className={isCompact ? "font-600" : "font-700"}>{price.toLocaleString("ko-KR")}<span className={cn("font-600", isCompact && "typo-caption1")}>원</span></span></p>;
    $[0] = hotDeal;
    $[1] = isCompact;
    $[2] = onSelect;
    $[3] = isPartnerPoint;
    $[4] = rewardRateLabel;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    isPartnerPoint = $[3];
    rewardRateLabel = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
  }
  let t9;
  if ($[32] !== hotDeal.rewardCurrencyType || $[33] !== isPartnerPoint || $[34] !== rewardRateLabel) {
    t9 = rewardRateLabel ? <p className="flex items-center gap-2"><PointCoin currency={hotDeal.rewardCurrencyType ?? "WELLO_POINT"} size={15} /><span className={cn("font-600 typo-caption2", isPartnerPoint ? "text-B-550" : "text-Y-600")}>{rewardRateLabel}{isPartnerPoint ? " \uC81C\uD734\uD3EC\uC778\uD2B8" : null}</span></p> : null;
    $[32] = hotDeal.rewardCurrencyType;
    $[33] = isPartnerPoint;
    $[34] = rewardRateLabel;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  let t10;
  if ($[36] !== t2 || $[37] !== t3 || $[38] !== t4 || $[39] !== t5 || $[40] !== t9) {
    t10 = <div className={t2}>{t3}{t4}{t5}{t9}</div>;
    $[36] = t2;
    $[37] = t3;
    $[38] = t4;
    $[39] = t5;
    $[40] = t9;
    $[41] = t10;
  } else {
    t10 = $[41];
  }
  let t11;
  if ($[42] !== t10 || $[43] !== t6 || $[44] !== t7 || $[45] !== t8) {
    t11 = <button onClick={t6} className={t7}>{t8}{t10}</button>;
    $[42] = t10;
    $[43] = t6;
    $[44] = t7;
    $[45] = t8;
    $[46] = t11;
  } else {
    t11 = $[46];
  }
  return t11;
};